import { memo, useState } from "react";
import Form from "../Form";
import { useSnackbar } from "../../utils/index.js"
import Spinner from "../Spinner.js"
import { Typography } from "@mui/material";
import AreYouSurePopup from "../popups/AreYouSurePopup.js";
import {
    endLambingPeriodByDateRange,
    countLambsToRelease,
} from "../../api/index.js";

const WeaningForm = ({
    datePickerWidth = "595px",
    selectedOwner,
    selectedStartDate,
    selectedEndDate,
    setIsAnimalSelected,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [weaningDateValue, setWeaningDateValue] = useState(null);
    const [lambCount, setLambCount] = useState(0);

    const { success, error } = useSnackbar();

    const weaningForm = [
        {
            customType: "date-picker",
            id: "weaningDate",
            type: "desktop",
            label: "Ημ/νία λήξης περιόδου Αμνών",
            width: datePickerWidth,
            background: "third",
            required: true
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Λήξη Περιόδου",
        },
    ]

    const handleWeaningSubmit = async (values) => {
        setIsLoading(true);
        setWeaningDateValue(values.weaningDate);

        // Fetch count of lambs that will be affected
        const { success: scs, count, message } = await countLambsToRelease(selectedOwner._id, {
            start: selectedStartDate,
            end: selectedEndDate,
        });

        if (scs) {
            setLambCount(count);
            setIsPopupOpen(true);
        } else {
            error(message);
        }

        setIsLoading(false);
    }

    const handleConfirmWeaning = async () => {
        setIsLoading(true);
        setIsPopupOpen(false);

        const { success: scs, message } = await endLambingPeriodByDateRange(selectedOwner._id, {
            start: selectedStartDate,
            end: selectedEndDate,
            weaningDate: weaningDateValue,
        });

        if (scs) {
            setIsAnimalSelected(false);
            success(message);
        } else {
            error(message);
        }

        setIsLoading(false);
        setWeaningDateValue(null);
        setLambCount(0);
    }

    return (
        <>
            <Spinner open={isLoading} />
            <AreYouSurePopup
                width={"900px"}
                isOpen={isPopupOpen}
                title="Λήξη Περιόδου Αμνών"
                titleColor="black"
                onClose={() => {
                    setIsPopupOpen(false);
                    setWeaningDateValue(null);
                    setLambCount(0);
                }}
                innerText={`Θα αποδεσμευτούν ${lambCount} κωδικοί αμνών της επιλεγμένης περιόδου. Οι παρόντες αμνοί θα αλλάξουν σε άγνωστη κατάσταση και οι παλιοί κωδικοί θα διατηρηθούν στο ιστορικό τους. Είστε σίγουροι;`}
                declineText="Ακύρωση"
                onDecline={() => {
                    setIsPopupOpen(false);
                    setWeaningDateValue(null);
                    setLambCount(0);
                }}
                acceptText="Επιβεβαίωση"
                onAccept={handleConfirmWeaning}
            />
            <Typography variant="h5" sx={{ margin: "1rem" }}>
                {`Λήξη Περιόδου Αμνών για την εκτροφή ${selectedOwner?.lastName} ${selectedOwner?.firstName}`}
            </Typography>
            <Typography variant="subtitle1" sx={{ margin: "1rem", marginTop: "0rem" }}>
                {`Περίοδος Τοκετών: ${new Date(selectedStartDate).toLocaleDateString("el-GR")} - ${new Date(selectedEndDate).toLocaleDateString("el-GR")}`}
            </Typography>
            <Form content={weaningForm} onSubmit={handleWeaningSubmit} />
        </>
    )
}

export default memo(WeaningForm)
